import { Instance } from '@const/consts'

const domain = 'https://docuforce.infologistics.'
const domainBR = 'https://docuforce.ilsbrasil.'
const domainVI = 'https://docuforce.ilsglobal.'
const domainCOZA = 'https://docuforce.ilssa.'
const domainCOZAmetrofile = 'https://docuforce.metrofile.'

export const dropdownItems = [
  {
    name: Instance.GLOBAL,
    translation: domain + Instance.GLOBAL
  },
  {
    name: Instance.BRASIL,
    translation: domainBR + Instance.BRASIL
  },
  {
    name: Instance.RUSSIAN,
    translation: domain + Instance.RUSSIAN
  },
  {
    name: Instance.SOUTH_AFRICA,
    translation: domainCOZA + Instance.SOUTH_AFRICA
  },
  {
    name: Instance.SOUTH_AFRICA + "__metrofile",
    translation: domainCOZAmetrofile + 'co.za'
  },
  {
    name: Instance.VIETNAMESE,
    translation: domainVI + Instance.VIETNAMESE
  }
]
